import getImageUrl from '../../../functions/getImageUrl'
import ListItem from '../presents/ListItem'
import hasDisplayTimes from '../functions/hasDisplayTimes'
import isOutOfRange from '../functions/isOutOfRange'
import { MOVIE } from '../../../constants/itemTypes'
import ListItemNoDataContainer from './ListItemNoDataContainer'

const ListItemMovieContainer = ({
    itemType=MOVIE,
    itemData,
    additionalClass,
    isSelected,
    basePreviewUrl,
    additionalButton='',
    pathnameEdit,
    onDelete,
}) => {
    if(!itemData) {
        return <ListItemNoDataContainer onDelete={onDelete} />
    }

    const { title, images, tempPyMoviePoster, titleDisplay, released } = itemData
    const currentTitle = titleDisplay ? titleDisplay : title
    const releasedClass = !itemData.hasOwnProperty('released') ? '' : released ? '' : ' not-released'

    const hasTimes = hasDisplayTimes(itemData)
    const outRange = hasTimes && isOutOfRange(itemData)

    const poster = images && images.poster && images.poster.url ? images.poster : null
    // tempPyMoviePoster is a plain url string, poster is an image object -> urlOnly switch
    const {finalImageURl, imageUrl} = poster
        ? getImageUrl(poster, false, true)
        : getImageUrl(tempPyMoviePoster ? tempPyMoviePoster : null, false, true, false, true)

    return <ListItem
        title={currentTitle}
        showImage={true}
        imageSrc={finalImageURl}
        imageSrcFallback={imageUrl}
        type={itemType}
        itemId={itemData.id}
        additionalClass={additionalClass + releasedClass}
        isSelected={isSelected}
        hasDisplayTimes={hasTimes}
        basePreviewUrl={basePreviewUrl}
        isOutOfRange={outRange}
        additionalButton={additionalButton}
        pathnameEdit={pathnameEdit}
        onDelete={onDelete}
    />
}

export default ListItemMovieContainer